import { IMenu, ITemplate } from '@/types/menu';
import request from '@/utils/request';
import { AxiosPromise } from 'axios';

export default {
  getMenuInfo: () =>
    request({
      url: '/menu_json',
    }) as AxiosPromise<IMenu[]>,

  setMenuInfo: (menuData: IMenu[], lang: string = 'zh_cn') =>
    request({
      method: 'post',
      url: '/menu_json',
      data: { pages: menuData, lang },
    }),
  fetchTemplates: () =>
    request({
      url: '/menu_json/templates',
    }) as AxiosPromise<ITemplate[]>,

  moveItemToPage: ({
    pathFrom,
    pathTo,
    itemId,
  }: {
    pathFrom: string;
    pathTo: string;
    itemId: string;
  }) =>
    request({
      method: 'put',
      url: `/crud${pathFrom}/detail/${itemId}/pagePattern`,
      data: { pagePattern: pathTo },
    }),
};
